<div bookviewerAccessbilityComponent
     [badgeInstruction]="'Drücke Enter um in die Werkzeug-Auswahl zu gelangen'"
    [class.scroll]="applicationStateService.currentViewMode.slug==='scroll'"
    class="tools-bar">
    <div class="tools-bar-container">
        <app-zoom-slider></app-zoom-slider>
        <hr/>
        <button (click)="toggleAreaHighlighting($event)"
           (keydown.esc)="onEscToggleButton()"
           [class.active]="applicationStateService.pageEditMode && applicationStateService.pageEditMode.type === 'RECT'"
           class="reveal"
           data-bs-placement="left"
           data-bs-toggle="tooltip"
           title="Notizen"
        >
            <img [src]="'draw-mode/icon-tool-notes.png' | asset" alt="Notizenmodus" class="sidebar-icon">
        </button>
        <button (click)="toggleTextHighlighting($event)"
           (keydown.esc)="onEscToggleButton()"
           [class.active]="applicationStateService.pageEditMode && applicationStateService.pageEditMode.type === 'SELECTION'"
           class="reveal"
           data-bs-placement="left"
           data-bs-toggle="tooltip"
           title="Textmarkierung"
        >
            <img [src]="'draw-mode/icon-tool-marker.png' | asset" alt="Textmarkierung" class="sidebar-icon">
        </button>
        <button (click)="toggleTextCopying($event)"
           (keydown.esc)="onEscToggleButton()"
           [class.active]="applicationStateService.pageEditMode && applicationStateService.pageEditMode.type === 'COPY'"
           class="reveal"
           data-bs-container="body"
           data-bs-placement="left"
           data-bs-toggle="tooltip"
           data-bs-trigger="hover"
           title="Text kopieren"
        >
            <img [src]="'draw-mode/icon-tool-copy.png' | asset" alt="Text kopieren" class="sidebar-icon">
        </button>
        <hr/>
        <div [class.open]="applicationStateService.pageEditMode && applicationStateService.pageEditMode.type === 'DRAW'"
             (hide.bs.dropdown)="drawbar.closeDrawBar()"
             class="dropdown">
            <div class="dropdown-tooltip"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  data-bs-placement="left"
                  data-bs-trigger="hover"
                  title="Zeichnen & Stempeln">
            <button (click)="toggleDrawing($event)"
                    [class.active]="applicationStateService.pageEditMode && applicationStateService.pageEditMode.type === 'DRAW'"
                    class="btn dropdown-toggle dropup mobile-tools-button" data-bs-auto-close="false"
                    data-bs-container="body"
                    data-bs-offset="-50,-32"
                    data-bs-toggle="dropdown"
                    id="drawing-tools"
                    type="button">
                <img [src]="'draw-mode/icon-tool-drawing.png' | asset" alt="Zeichnen & Stempeln" class="sidebar-icon">
            </button>
            </div>
            <ul aria-labelledby="mobile-tools" class="dropdown-menu dropdown-menu-end draw-bar">
                <app-draw-bar #drawbar [isMobileVersion]="false"></app-draw-bar>
            </ul>
        </div>
        <hr/>
        <div class="dropdown-tooltip"
              data-bs-toggle="tooltip"
              data-bs-html="true"
              data-bs-placement="left"
              data-bs-trigger="hover"
              title="Seite(n) herunterladen">
        <div class="dropdown">
            <button (click)="hideTooltipsAndCloseTools()"
                    [disabled]="applicationStateService.isOfflineModeEnabled" aria-expanded="true" aria-haspopup="true"
                    class="btn dropdown-toggle dropup mobile-tools-button download" data-bs-container="body"
                    data-bs-offset="-40,-32"
                    data-bs-toggle="dropdown" id="mobile-tools"
                    type="button">
                <img alt="Als PDF herunterladen" src="{{ 'download-page.png' | asset }}"/>
            </button>
            <ul aria-labelledby="mobile-tools" class="dropdown-menu dropdown-menu-end">
                <app-tools-bar-drop-up [isMobileVersion]="false"></app-tools-bar-drop-up>
            </ul>
        </div>
        </div>
    </div>

    @if (applicationStateService.currentViewMode.slug === 'scroll') {
        <div class="tools-bar-container">
            <div class="scroll-page-switcher">
                <app-page-switcher></app-page-switcher>
            </div>
        </div>
    }
</div>

